export default __webpack_public_path__ + "static/media/menu.267c1596.svg";